module.exports = __webpack_public_path__ + "icon_person_add-e2c6b660f6e1c95785d8d2bfa7a823af.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_person_add.png
// module id = 277
// module chunks = 86